export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8248.7a2c447d.jpg";